define('OutSystems/ClientRuntime/Controller',["require", "exports", "tslib", "./ApplicationInfo", "./Communication", "./DataConversion", "./DataTypes", "./ErrorHandling", "./Exceptions", "./Flow", "./Injector", "./Injector/KnownServices", "./Logger", "./NativeHelper", "./Navigation", "./PublicApiHelper", "./RequireManager", "./RolesInfo", "./Validation", "./VersionsManager", "./WidgetNaming"], function (require, exports, tslib_1, ApplicationInfo, Communication, DataConversion_1, DataTypes, ErrorHandling, Exceptions, Flow, Injector_1, KnownServices_1, Logger, NativeHelper, Navigation, PublicApiHelper_1, RequireManager, RolesInfo, Validation_1, VersionsManager_1, WidgetNaming_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.BaseViewController = exports.BaseModuleController = exports.BaseController = exports.IterationContext = exports.CallContext = exports.ControllerFactory = void 0;
    var NOOP = function () { };
    var ANY_SCREEN_KEY = "*";
    var ControllerFactory = (function () {
        function ControllerFactory(controllerClass, messagesProvider) {
            this.controllerClass = controllerClass;
            this.messagesProvider = messagesProvider;
        }
        ControllerFactory.prototype.create = function (model, idService) {
            return new this.controllerClass(model, this.messagesProvider, idService);
        };
        ControllerFactory.executeWithNavigationCallbacks = function (action, navigationCallbacks, callContext) {
            Navigation.setNavigationCallbacks(navigationCallbacks);
            var dispose = function () {
                navigationCallbacks.dispose(callContext);
                Navigation.removeNavigationCallbacks();
            };
            return Flow.tryFinally(action, dispose);
        };
        ControllerFactory.prototype.initialize = function (modelContext, modelFactory, webflowClass, checkPermissionsNavigationCallbacks, controllerInitializationNavigationCallbacks) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var activeScreen, currentViewContext, e_1, result_1, model, controller, initializePromise, result;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            activeScreen = BaseViewController.activeScreen;
                            currentViewContext = !activeScreen ? webflowClass.callContext() : activeScreen.callContext();
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 4, , 5]);
                            if (!(RolesInfo.getUserId() !== 0 && !RolesInfo.areRolesDefined())) return [3, 3];
                            return [4, new Promise(function (resolve) {
                                    new PublicApiHelper_1.PublicApiHelper(null, null).ApplicationLifecycle.listen({
                                        onLoadComplete: resolve,
                                    });
                                })];
                        case 2:
                            _a.sent();
                            _a.label = 3;
                        case 3:
                            this.controllerClass.checkPermissions();
                            return [3, 5];
                        case 4:
                            e_1 = _a.sent();
                            result_1 = {
                                permissionsOk: false,
                            };
                            return [2, ControllerFactory.executeWithNavigationCallbacks(function () { return webflowClass.handleError(e_1, currentViewContext); }, checkPermissionsNavigationCallbacks, currentViewContext).then(function () { return result_1; }, function (error) { return result_1; })];
                        case 5:
                            model = modelFactory.create(modelContext);
                            controller = this.create(model, new WidgetNaming_1.WidgetIdService(null));
                            controller.setAsActiveScreen();
                            initializePromise = ControllerFactory.executeWithNavigationCallbacks(function () { return controller.fireInitialize(); }, controllerInitializationNavigationCallbacks, controller.callContext());
                            result = {
                                permissionsOk: true,
                                controller: controller,
                                model: model,
                            };
                            return [2, initializePromise.then(function () { return result; }, function (error) {
                                    if (Exceptions.isInstanceOf(error, Exceptions.Exceptions.UnhandledOrIgnoredErrorInEventException) &&
                                        error.handleErrorResult ===
                                            ErrorHandling.UNHANDLED_ERROR_RESULT) {
                                        return {
                                            permissionsOk: true,
                                        };
                                    }
                                    else {
                                        return result;
                                    }
                                })];
                    }
                });
            });
        };
        Object.defineProperty(ControllerFactory.prototype, "activeScreenController", {
            get: function () {
                return BaseViewController.activeScreen;
            },
            enumerable: false,
            configurable: true
        });
        return ControllerFactory;
    }());
    exports.ControllerFactory = ControllerFactory;
    var CallContext = (function () {
        function CallContext() {
            this._iterationContext = new IterationContext();
            this._id = ++CallContext.currentId;
        }
        Object.defineProperty(CallContext.prototype, "id", {
            get: function () {
                return this._id;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(CallContext.prototype, "viewName", {
            get: function () {
                return this._viewName;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(CallContext.prototype, "timeout", {
            get: function () {
                return this._timeout;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(CallContext.prototype, "iterationContext", {
            get: function () {
                return this._iterationContext;
            },
            set: function (newIterationContext) {
                this._iterationContext = newIterationContext;
            },
            enumerable: false,
            configurable: true
        });
        CallContext.prototype.withViewName = function (newViewName) {
            if (this._viewName !== newViewName) {
                return this.innerClone({
                    _viewName: { value: newViewName },
                });
            }
            return this;
        };
        CallContext.prototype.withTimeout = function (newTimeout) {
            if (this._timeout !== newTimeout) {
                return this.innerClone({
                    _timeout: { value: newTimeout },
                });
            }
            return this;
        };
        CallContext.prototype.clone = function () {
            var clonedCallContext = this.innerClone();
            clonedCallContext._id = ++CallContext.currentId;
            return clonedCallContext;
        };
        CallContext.prototype.innerClone = function (extraProperties) {
            var ccClone = Object.create(this, extraProperties);
            ccClone.iterationContext = this.iterationContext.clone();
            return ccClone;
        };
        Object.defineProperty(CallContext.prototype, "isOutOfContext", {
            get: function () {
                return !!BaseViewController.activeScreen && this.viewName !== BaseViewController.activeScreen.viewName;
            },
            enumerable: false,
            configurable: true
        });
        CallContext.currentId = 0;
        return CallContext;
    }());
    exports.CallContext = CallContext;
    var IterationContext = (function () {
        function IterationContext() {
        }
        IterationContext.prototype.getCurrentRowNumber = function (list) {
            var iterator = this.getIterator(list);
            if (iterator) {
                return iterator.currentRowNumber;
            }
            else {
                return 0;
            }
        };
        IterationContext.prototype.setCurrentRowNumber = function (list, currentRowNumber) {
            var iterator = this.getIteratorForSet(list);
            iterator.currentRowNumber = currentRowNumber;
        };
        IterationContext.prototype.isBeingIterated = function (list) {
            var iterator = this.getIterator(list);
            if (iterator) {
                return iterator.isBeingIterated;
            }
            else {
                return false;
            }
        };
        IterationContext.prototype.registerIterationStart = function (list) {
            var iterator = this.getIteratorForSet(list);
            if (iterator.isBeingIterated) {
                throw new Error("List is already being iterated in this context");
            }
            iterator.currentRowNumber = list.length - 1;
            iterator.isBeingIterated = true;
        };
        IterationContext.prototype.registerIterationEnd = function (list) {
            var iterator = this.getIteratorForSet(list);
            if (!iterator.isBeingIterated) {
                throw new Error("List was redefined while being iterated");
            }
            iterator.isBeingIterated = false;
        };
        IterationContext.prototype.getIterator = function (list) {
            if (this.iterators) {
                return this.iterators.get(list.modelId);
            }
            else {
                return null;
            }
        };
        IterationContext.prototype.getIteratorForSet = function (list) {
            if (!this.iterators) {
                this.iterators = new Map();
            }
            var iterator = this.getIterator(list);
            if (!iterator) {
                iterator = {
                    currentRowNumber: 0,
                    isBeingIterated: false,
                };
                this.iterators.set(list.modelId, iterator);
            }
            return iterator;
        };
        IterationContext.prototype.clone = function () {
            var clonedContext = new IterationContext();
            if (this.iterators) {
                clonedContext.iterators = cloneMap(this.iterators, function (value) { return Object.create(value); });
            }
            return clonedContext;
        };
        return IterationContext;
    }());
    exports.IterationContext = IterationContext;
    function cloneMap(map, cloneValue) {
        var newMap = new Map();
        map.forEach(function (value, key) {
            var clonedValue = cloneValue(value);
            newMap.set(key, clonedValue);
        });
        return newMap;
    }
    var VariableGroupTypeFactory = new DataTypes.RecordTypeFactory();
    var JSONDeserializeOutputTypeFactory = new DataTypes.ComplexTypeKeyedTypeFactory("Data", "dataOut");
    var AggregateOutputTypeFactory = new DataTypes.ComplexTypeKeyedTypeFactory("List", "listOut", [
        {
            name: "Count",
            attrName: "countOut",
            mandatory: true,
            dataType: DataTypes.DataTypes.LongInteger,
            defaultValue: function () { return DataTypes.LongInteger.defaultValue; },
        },
    ]);
    var BASE_CONTROLLER_MODULE_NAME = "BaseController";
    var BaseController = (function () {
        function BaseController(translationResources) {
            var _this = this;
            this.isExecutingJSNode = false;
            this.localeChangeHandler = function (data) {
                var _a;
                var translationsService = Injector_1.default.resolve(KnownServices_1.ServiceNames.TranslationsService);
                var localeService = Injector_1.default.resolve(KnownServices_1.ServiceNames.LocaleService);
                if (translationsService) {
                    var localeCodes = (_a = data.localeFamily) !== null && _a !== void 0 ? _a : [data.localeCode];
                    localeCodes.forEach(function (localeCode) {
                        var _a, _b;
                        if (_this.translationResources[localeCode]) {
                            Logger.trace(BASE_CONTROLLER_MODULE_NAME, "Adding translations for " + localeCode + " locale.");
                            translationsService.add((_a = _this.translationResources[localeCode].translations) !== null && _a !== void 0 ? _a : {});
                            localeService.setCurrentLocaleRTL((_b = _this.translationResources[localeCode].isRTL) !== null && _b !== void 0 ? _b : false);
                        }
                        else {
                            Logger.trace(BASE_CONTROLLER_MODULE_NAME, "No translations found for " + localeCode + " locale.");
                        }
                    });
                }
            };
            this.translationResources = translationResources !== null && translationResources !== void 0 ? translationResources : this.translationResources;
            if (this.translationResources) {
                var localeService = Injector_1.default.resolve(KnownServices_1.ServiceNames.LocaleService);
                if (localeService) {
                    var localeCode = localeService.getCurrentLocale();
                    var localeFamily = localeService.getCurrentLocaleFamily();
                    this.localeChangeHandler({ localeCode: localeCode, localeFamily: localeFamily });
                    Logger.trace(BASE_CONTROLLER_MODULE_NAME, "Subscribing handler for locale service.");
                    localeService.subscribe(this.localeChangeHandler);
                }
            }
        }
        Object.defineProperty(BaseController.prototype, "publicApiHelper", {
            get: function () {
                if (!this._publicApiHelper) {
                    this._publicApiHelper = this.createPublicApiHelper();
                }
                return this._publicApiHelper;
            },
            enumerable: false,
            configurable: true
        });
        BaseController.prototype.getDefaultTimeout = function () {
            throw new Error("Controllers must implement getDefaultTimeout");
        };
        BaseController.prototype.createPublicApiHelper = function () {
            return new PublicApiHelper_1.PublicApiHelper(null, this.callContext());
        };
        Object.defineProperty(BaseController.prototype, "default", {
            get: function () {
                return this;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(BaseController.prototype, "controller", {
            get: function () {
                return this;
            },
            enumerable: false,
            configurable: true
        });
        BaseController.prototype.callContext = function (currentContext) {
            if (currentContext === void 0) { currentContext = new CallContext(); }
            return currentContext;
        };
        BaseController.prototype.safeExecuteJSNode = function (executeJSNode, jsNodeName, actionName, args, convertResults, actions, roles, isAsync) {
            if (isAsync === void 0) { isAsync = false; }
            var handleException = function (ex) {
                var message = "Check the JavaScript node '" + jsNodeName + "' of the action '" + actionName + "'.";
                ex = ex || new Error(message);
                if (ex instanceof Exceptions.Exceptions.NumberOverflowException ||
                    ex instanceof Exceptions.Exceptions.InvalidJavascriptType) {
                    ex.message = ex.message + " " + message;
                }
                throw ex;
            };
            var previousIsExecutingJSNode = this.isExecutingJSNode;
            var jsNodeContext = (args ? [args] : []).concat(actions, roles, this.publicApiHelper);
            executeJSNode = executeJSNode.bind.apply(executeJSNode, tslib_1.__spreadArray([null], jsNodeContext));
            try {
                this.isExecutingJSNode = true;
                if (isAsync) {
                    return executeJSNode().then(function () { return convertResults(args); }).catch(handleException);
                }
                try {
                    executeJSNode();
                    return convertResults(args);
                }
                catch (ex) {
                    handleException(ex);
                }
            }
            finally {
                this.isExecutingJSNode = previousIsExecutingJSNode;
            }
        };
        BaseController.prototype.safeExecuteAsyncJSNode = function (functionToCall, jsNodeName, actionName, args, convertResults, actions, roles) {
            return this.safeExecuteJSNode(functionToCall, jsNodeName, actionName, args, convertResults, actions, roles, true);
        };
        BaseController.prototype.executeActionInsideJSNode = function (functionToCall, callContext, wrapResults, flush, actionName) {
            if (wrapResults === void 0) { wrapResults = NOOP; }
            if (flush === void 0) { flush = NOOP; }
            if (actionName === void 0) { actionName = ""; }
            var handleException = function (ex) {
                if (!ErrorHandling.ignoreError(ex, callContext)) {
                    throw ex;
                }
            };
            try {
                if (actionName) {
                    try {
                        this.ensureControllerAlive(actionName);
                    }
                    catch (ex) {
                        Logger.error("Controller", ex);
                        throw ex;
                    }
                }
                var result = functionToCall(callContext);
                if (result instanceof Promise) {
                    return result
                        .then(function (r) {
                        flush();
                        return wrapResults(r);
                    })
                        .catch(function (e) {
                        flush();
                        handleException(e);
                    });
                }
                else {
                    return wrapResults(result);
                }
            }
            catch (e) {
                handleException(e);
            }
            finally {
                if (!this.isExecutingJSNode) {
                    flush();
                }
            }
        };
        BaseController.prototype.getInitialPayloadObject = function (context, apiVersion) {
            return {
                versionInfo: {
                    moduleVersion: VersionsManager_1.default.getLastApplicationVersionToken(true),
                    apiVersion: apiVersion,
                },
                viewName: context.viewName ? context.viewName : ANY_SCREEN_KEY,
            };
        };
        BaseController.prototype.getEffectiveTimeoutForServerCall = function (timeout) {
            var appDefaultTimeout = ApplicationInfo.getApplicationDefaultTimeout();
            return appDefaultTimeout || timeout || this.getDefaultTimeout();
        };
        BaseController.prototype.callServerAction = function (actionName, url, apiVersion, inputParameters, callContext, headers, onResponseParsed, useLocaleInfo) {
            if (useLocaleInfo === void 0) { useLocaleInfo = false; }
            return this.innerCallServerAction(actionName, url, apiVersion, inputParameters, callContext, headers, onResponseParsed, useLocaleInfo);
        };
        BaseController.prototype.innerCallServerAction = function (actionName, url, apiVersion, inputParameters, callContext, headers, onResponseParsed, useLocaleInfo) {
            if (useLocaleInfo === void 0) { useLocaleInfo = false; }
            var effectiveTimeout = this.getEffectiveTimeoutForServerCall(callContext.timeout);
            var payload = this.getInitialPayloadObject(callContext, apiVersion);
            payload.inputParameters = inputParameters;
            var communicationExceptionMessage = "The timeout of " + effectiveTimeout + "s was reached while executing this server action.";
            var onTimeout = function () {
                Logger.trace(actionName, communicationExceptionMessage);
            };
            return Communication.post(url, payload, ApplicationInfo.getBasePath(), effectiveTimeout, onTimeout, BaseController.createPostResponseHandler(onResponseParsed), undefined, undefined, headers, useLocaleInfo)
                .then(function (data) {
                return data || {};
            })
                .catch(function (ex) {
                ex.extraStack = actionName;
                throw ex;
            });
        };
        BaseController.checkPermissions = function () {
            throw new Error("Screen Controllers must implement checkPermissions");
        };
        BaseController.handlePostResponse = function (json) {
            if (!!json.rolesInfo) {
                RolesInfo.storeRoleInformation(json.rolesInfo);
            }
            var clientVariableService = Injector_1.default.resolve(KnownServices_1.ServiceNames.ClientVariablesService);
            if (clientVariableService) {
                clientVariableService.checkSessionExpires();
            }
        };
        BaseController.createPostResponseHandler = function (customHandler) {
            return function (json, headers) {
                BaseController.handlePostResponse(json);
                if (customHandler) {
                    customHandler(json, headers);
                }
            };
        };
        BaseController.prototype.executeClientAggregate = function (executeQuery, getAggregate) {
            return Flow.executeSequence(function () {
                return executeQuery();
            }).then(function (result) {
                var aggregate = getAggregate();
                aggregate.listOut = result.list;
                aggregate.countOut = result.count;
            });
        };
        BaseController.prototype.ensureControllerAlive = function (actionName) { };
        BaseController.getJSONDeserializeOutputType = function (typeConstructor) {
            return JSONDeserializeOutputTypeFactory.getType(typeConstructor);
        };
        BaseController.getAggregateOutputType = function (listType) {
            return AggregateOutputTypeFactory.getType(listType);
        };
        BaseController.registerVariableGroupType = function (typeId, attrs) {
            VariableGroupTypeFactory.registerTypeDefinition(typeId, attrs);
        };
        BaseController.getVariableGroupType = function (typeId) {
            return VariableGroupTypeFactory.getType(typeId);
        };
        return BaseController;
    }());
    exports.BaseController = BaseController;
    var BaseModuleController = (function (_super) {
        tslib_1.__extends(BaseModuleController, _super);
        function BaseModuleController() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.fireApplicationResumeSingletonCallback = _this.fireApplicationResume.bind(_this);
            return _this;
        }
        BaseModuleController.prototype.registerEventHandler = function (eventActionModule, eventActionName, handlerSetter) {
            var _this = this;
            handlerSetter(function () {
                return new Promise(function (resolve, reject) {
                    RequireManager.loadModule([eventActionModule], resolve, reject);
                }).then(function () {
                    var eventAction = _this[eventActionName];
                    var newEventHandler = function () { return Promise.resolve().then(function () { return eventAction.call(_this); }); };
                    handlerSetter(newEventHandler);
                    return newEventHandler();
                });
            });
        };
        BaseModuleController.prototype.registerOnApplicationReadyHandler = function (eventActionModule, eventActionName) {
            var _this = this;
            this.registerEventHandler(eventActionModule, eventActionName, function (handler) { return (_this.onApplicationReadyHandler = handler); });
        };
        BaseModuleController.prototype.registerOnApplicationResumeHandler = function (eventActionModule, eventActionName) {
            var _this = this;
            this.registerEventHandler(eventActionModule, eventActionName, function (handler) { return (_this.onApplicationResumeHandler = handler); });
        };
        BaseModuleController.prototype.fireApplicationReady = function () {
            var _this = this;
            if (!!this.onApplicationReadyHandler) {
                return this.onApplicationReadyHandler().then(function () { return _this.setupOnApplicationResumeListener(); });
            }
            else {
                this.setupOnApplicationResumeListener();
                return Promise.resolve(undefined);
            }
        };
        BaseModuleController.prototype.setupOnApplicationResumeListener = function () {
            if (!!this.onApplicationResumeHandler) {
                NativeHelper.addNativeEventListener("resume", this.fireApplicationResumeSingletonCallback);
            }
        };
        BaseModuleController.prototype.fireApplicationResume = function () {
            if (!!this.onApplicationResumeHandler) {
                return this.onApplicationResumeHandler();
            }
            else {
                return Promise.resolve(undefined);
            }
        };
        return BaseModuleController;
    }(BaseController));
    exports.BaseModuleController = BaseModuleController;
    var BaseViewController = (function (_super) {
        tslib_1.__extends(BaseViewController, _super);
        function BaseViewController(model, messagesProvider, _idService, translationResources) {
            var _this = _super.call(this, translationResources) || this;
            _this.model = model;
            _this.messagesProvider = messagesProvider;
            _this._idService = _idService;
            _this.instanceId = BaseViewController.globalInstanceId++;
            _this.isDisposed = false;
            _this.shouldSendClientVarsToDataSources = false;
            _this.fetchReadySources = function (completedSource) {
                var readyToExecute = [];
                var actionsToCheck = completedSource === undefined ? _this.dataFetchActionNames : _this.dataFetchDependentsGraph[completedSource];
                actionsToCheck.forEach(function (action) {
                    if (completedSource) {
                        _this.dataFetchDependencies[action]--;
                    }
                    if (_this.dataFetchDependencies[action] === 0) {
                        readyToExecute.push(action);
                    }
                });
                readyToExecute.forEach(function (action) {
                    _this.remainingFetchesCount++;
                    _this.dataFetchDependencies[action] = -1;
                    _this.executeDataFetchAction(action).then(function () { return _this.fetchReadySources(action); });
                });
            };
            _this.clientVariablesHandler = function (data) {
                _this.model.clientVariablesGeneration++;
                _this.model.scheduleFlush();
            };
            _this.localeDependencyHandler = function (data) {
                _this.model.currentLocale = data.localeCode;
                _this.model.scheduleFlush();
            };
            var localeService = Injector_1.default.resolve(KnownServices_1.ServiceNames.LocaleService);
            if (localeService && _this.translationResources) {
                _this.model.currentLocale = localeService.getCurrentLocale();
            }
            _this.validationServiceInstance = new Validation_1.ValidationService(model, messagesProvider);
            return _this;
        }
        BaseViewController.prototype.fireEvent = function (event) {
            var _this = this;
            return Flow.executeSequence(function () {
                if (!!event) {
                    return event.call(_this, _this.callContext());
                }
            }).then(function (result) {
                if (ErrorHandling.isSpecialHandleErrorResult(result)) {
                    throw Exceptions.Exceptions.UnhandledOrIgnoredErrorInEventException.create(result);
                }
            });
        };
        BaseViewController.prototype.fireEventAndForget = function (event) {
            this.fireEvent(event).catch(Exceptions.Exceptions.UnhandledOrIgnoredErrorInEventException.ignore);
        };
        BaseViewController.prototype.createPublicApiHelper = function () {
            return new PublicApiHelper_1.PublicApiHelper(this.model, this.callContext());
        };
        Object.defineProperty(BaseViewController, "activeScreen", {
            get: function () {
                return BaseViewController.activeScreenInstance;
            },
            enumerable: false,
            configurable: true
        });
        BaseViewController.prototype.setAsActiveScreen = function () {
            BaseViewController.activeScreenInstance = this;
        };
        BaseViewController.prototype.callContext = function (currentContext) {
            return _super.prototype.callContext.call(this, currentContext).withViewName(this.viewName);
        };
        Object.defineProperty(BaseViewController.prototype, "validationService", {
            get: function () {
                return this.validationServiceInstance;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(BaseViewController.prototype, "viewName", {
            get: function () {
                return this.modelContext ? this.modelContext.viewName : undefined;
            },
            enumerable: false,
            configurable: true
        });
        BaseViewController.prototype.fetchData = function () {
            var dataFetched = false;
            Logger.trace(this, "Using Improved data fetching with dependencies");
            dataFetched = this.innerFetchDataWithDependencies();
            if (dataFetched) {
                this.model.flush();
            }
        };
        BaseViewController.prototype.executeDataFetchAction = function (actionName) {
            var _this = this;
            Logger.trace(this, "Fetching " + actionName);
            return Flow.executeSequence(function () { return _this[actionName](); }).then(function () {
                _this.remainingFetchesCount--;
                clearTimeout(_this.flushTimeoutHandle);
                Logger.trace(_this, "Fetched " + actionName);
                if (_this.remainingFetchesCount > 0) {
                    _this.flushTimeoutHandle = setTimeout(function () { return _this.model.flush(); }, 50);
                }
                else {
                    _this.model.flush();
                }
            }, function (ex) {
                _this.remainingFetchesCount--;
                _this.model.flush();
                _this.handleError(ex);
            });
        };
        BaseViewController.prototype.innerFetchDataWithDependencies = function () {
            if (!this.dataFetchActionNames || this.dataFetchActionNames.length === 0) {
                return false;
            }
            this.dataFetchDependencies = tslib_1.__assign({}, this.dataFetchDependenciesOriginal);
            this.flushTimeoutHandle = 0;
            this.remainingFetchesCount = 0;
            this.fetchReadySources();
            return true;
        };
        Object.defineProperty(BaseViewController.prototype, "idService", {
            get: function () {
                return this._idService;
            },
            enumerable: false,
            configurable: true
        });
        BaseViewController.prototype.fireInitialize = function () {
            var _this = this;
            var clientVariablesService = Injector_1.default.resolve(KnownServices_1.ServiceNames.ClientVariablesService);
            if (clientVariablesService) {
                clientVariablesService.subscribe(this.clientVariablesHandler);
            }
            var localeService = Injector_1.default.resolve(KnownServices_1.ServiceNames.LocaleService);
            if (localeService) {
                localeService.subscribe(this.localeDependencyHandler);
            }
            return this.fireEvent(this.onInitializeEventHandler).then(function () { return _this.fetchData(); });
        };
        BaseViewController.prototype.fireAfterViewReady = function () {
            var _this = this;
            this.fireEvent(this.onReadyEventHandler)
                .then(function () { return _this.fireEvent(_this.onRenderEventHandler); })
                .catch(Exceptions.Exceptions.UnhandledOrIgnoredErrorInEventException.ignore);
        };
        BaseViewController.prototype.fireAfterInputsChanged = function () {
            this.fireEventAndForget(this.onParametersChangedEventHandler);
        };
        BaseViewController.prototype.fireAfterViewRender = function (renderLoopDetected) {
            var _this = this;
            if (renderLoopDetected === void 0) { renderLoopDetected = false; }
            if (this.onRenderEventHandler) {
                return this.fireEvent(function (context) {
                    if (renderLoopDetected) {
                        Logger.error("View", "Render loop avoided. " +
                            ("This is likely due to the model of the screen/block '" + _this.viewName + "' being changed inside its 'On Render' client action. ") +
                            "Avoid changes to the model inside 'On Render' client actions.");
                        return;
                    }
                    return _this.onRenderEventHandler(context);
                });
            }
        };
        BaseViewController.prototype.fireAfterViewDestroy = function (_a) {
            var _b = _a === void 0 ? {} : _a, _c = _b.clientVariablesService, clientVariablesService = _c === void 0 ? Injector_1.default.resolve(KnownServices_1.ServiceNames.ClientVariablesService) : _c, _d = _b.localeService, localeService = _d === void 0 ? Injector_1.default.resolve(KnownServices_1.ServiceNames.LocaleService) : _d;
            if (clientVariablesService) {
                clientVariablesService.unsubscribe(this.clientVariablesHandler);
            }
            if (localeService) {
                localeService.unsubscribe(this.localeDependencyHandler);
            }
            this.fireEventAndForget(this.onDestroyEventHandler);
        };
        BaseViewController.prototype.registerClientAction = function (actionName, action) {
            this[actionName] = action;
        };
        BaseViewController.prototype.innerCallAggregate = function (aggregateName, url, apiVersion, maxRecords, startIndex, setDataFetchStatus, setDataFromJS, timeout, headers, onResponseParsed, callContext, clientVariablesModule, useLocaleInfo) {
            if (useLocaleInfo === void 0) { useLocaleInfo = false; }
            var requestTimeout = this.getEffectiveTimeoutForServerCall(timeout);
            Logger.trace(this, "Calling " + aggregateName + " aggregate with start index endpoint");
            return this.callServerDataSource(aggregateName, url, apiVersion, setDataFetchStatus, setDataFromJS, function (input) {
                input.inputParameters = {
                    StartIndex: startIndex,
                    MaxRecords: maxRecords,
                };
            }, requestTimeout, headers, onResponseParsed, callContext, clientVariablesModule, useLocaleInfo);
        };
        BaseViewController.prototype.callAggregateWithStartIndexAndClientVars = function (aggregateName, url, apiVersion, maxRecords, startIndex, setDataFetchStatus, setDataFromJS, timeout, headers, onResponseParsed, callContext, clientVariablesModule, useLocaleInfo) {
            if (useLocaleInfo === void 0) { useLocaleInfo = false; }
            return this.innerCallAggregate(aggregateName, url, apiVersion, maxRecords, startIndex, setDataFetchStatus, setDataFromJS, timeout, headers, onResponseParsed, callContext, clientVariablesModule, useLocaleInfo);
        };
        BaseViewController.prototype.callAggregateWithStartIndex = function (aggregateName, url, apiVersion, maxRecords, startIndex, setDataFetchStatus, setDataFromJS, timeout, headers, onResponseParsed, callContext) {
            return this.innerCallAggregate(aggregateName, url, apiVersion, maxRecords, startIndex, setDataFetchStatus, setDataFromJS, timeout, headers, onResponseParsed, callContext);
        };
        BaseViewController.prototype.callAggregate = function (aggregateName, url, apiVersion, maxRecords, setDataFetchStatus, setDataFromJS, timeout, headers, onResponseParsed, callContext) {
            return this.innerCallAggregate(aggregateName, url, apiVersion, maxRecords, 0, setDataFetchStatus, setDataFromJS, timeout, headers, onResponseParsed, callContext);
        };
        BaseViewController.prototype.callDataAction = function (dataActionName, url, apiVersion, setDataFetchStatus, setDataFromJS, timeout, headers, onResponseParsed, callContext, clientVariablesModule, useLocaleInfo) {
            if (useLocaleInfo === void 0) { useLocaleInfo = false; }
            return this.innerCallDataAction(dataActionName, url, apiVersion, setDataFetchStatus, setDataFromJS, timeout, headers, onResponseParsed, callContext, clientVariablesModule, useLocaleInfo);
        };
        BaseViewController.prototype.innerCallDataAction = function (dataActionName, url, apiVersion, setDataFetchStatus, setDataFromJS, timeout, headers, onResponseParsed, callContext, clientVariablesModule, useLocaleInfo) {
            if (useLocaleInfo === void 0) { useLocaleInfo = false; }
            var requestTimeout = this.getEffectiveTimeoutForServerCall(timeout);
            return this.callServerDataSource(dataActionName, url, apiVersion, setDataFetchStatus, setDataFromJS, undefined, requestTimeout, headers, onResponseParsed, callContext, clientVariablesModule, useLocaleInfo);
        };
        BaseViewController.prototype.callServerDataSource = function (dataSourceActionName, url, apiVersion, setDataFetchStatus, setDataFromJS, customizePayload, timeout, headers, onResponseParsed, callContext, clientVariablesModule, useLocaleInfo) {
            var _this = this;
            if (customizePayload === void 0) { customizePayload = undefined; }
            if (timeout === void 0) { timeout = 0; }
            if (useLocaleInfo === void 0) { useLocaleInfo = false; }
            var payload = this.getInitialPayloadObject(this.callContext(), apiVersion);
            Logger.trace(this, "Calling " + dataSourceActionName + " data source with optimized on payload");
            payload.screenData = { variables: DataConversion_1.ServerDataConverter.to(this.model.variables, callContext, true) };
            if (!!customizePayload) {
                customizePayload(payload);
            }
            if (this.shouldSendClientVarsToDataSources && clientVariablesModule) {
                payload.clientVariables = clientVariablesModule.serialize();
            }
            setDataFetchStatus(0);
            var onTimeout = function () {
                Logger.trace(dataSourceActionName, "The timeout of " + timeout + "s was reached while fetching this screen data.");
            };
            return Flow.promise(function (resolve, reject) {
                Communication.post(url, payload, ApplicationInfo.getBasePath(), timeout, onTimeout, BaseViewController.createPostResponseHandler(onResponseParsed), true, _this.instanceId, headers, useLocaleInfo)
                    .then(function (data) {
                    if (_this.isDisposed) {
                    }
                    else {
                        setDataFromJS(data);
                        setDataFetchStatus(1);
                        return resolve();
                    }
                })
                    .catch(function (ex) {
                    if (!_this.isDisposed) {
                        if (!Exceptions.isInstanceOf(ex, Exceptions.Exceptions.ViewHasChangedException) &&
                            !Exceptions.isInstanceOf(ex, Exceptions.Exceptions.OutOfOrderException)) {
                            setDataFetchStatus(2);
                        }
                        return reject(ex);
                    }
                });
            });
        };
        BaseViewController.prototype.handleError = function (e) {
            throw new Error("@abstract");
        };
        BaseViewController.prototype.safeExecuteAsyncJSNode = function (functionToCall, jsNodeName, actionName, args, convertResult, actions, roles) {
            this.model.flush();
            return _super.prototype.safeExecuteAsyncJSNode.call(this, functionToCall, jsNodeName, actionName, args, convertResult, actions, roles);
        };
        BaseViewController.prototype.executeActionInsideJSNode = function (functionToCall, callContext, wrapResults, flush, actionName) {
            var _this = this;
            if (wrapResults === void 0) { wrapResults = NOOP; }
            if (flush === void 0) { flush = NOOP; }
            if (actionName === void 0) { actionName = "UNKNOWN"; }
            return _super.prototype.executeActionInsideJSNode.call(this, functionToCall, callContext, wrapResults, function () {
                flush();
                _this.model.flush();
            }, actionName);
        };
        BaseViewController.prototype.dispose = function () {
            this.validationService.dispose();
            this.isDisposed = true;
        };
        BaseViewController.prototype.ensureControllerAlive = function (actionName) {
            if (this.isDisposed) {
                var exception = new Exceptions.Exceptions.ControllerDisposedException("Invalid call of the '" + actionName + "' client action of the '" + this.viewName + "' since the latter is not currently active. " +
                    "This is likely due to a platform's client action being used as an event handler or in a setTimeout function. " +
                    "Consider removing this call by using the 'On Destroy' event of the screen/block or moving your logic to a global client action.");
                Logger.trace("Controller", exception.message);
                throw exception;
            }
        };
        BaseViewController.prototype.safeExecuteClientAction = function (functionToCall, callContext) {
            var _this = this;
            var args = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args[_i - 2] = arguments[_i];
            }
            return Flow.tryCatchFinally(function () { return functionToCall.apply(_this, args.concat(_this.callContext(callContext))); }, function (e) { return _this.handleError(e); }, function () { return _this.model.flush(); });
        };
        Object.defineProperty(BaseViewController.prototype, "modelContext", {
            get: function () {
                return this.model.context;
            },
            enumerable: false,
            configurable: true
        });
        BaseViewController.prototype.executeScreenClientAggregate = function (executeQuery, getAggregate, onAfterFetch) {
            var _this = this;
            return Flow.executeSequence(function () {
                getAggregate().dataFetchStatusAttr = 0;
                return executeQuery();
            }).then(function (result) {
                if (_this.isDisposed) {
                }
                else {
                    getAggregate().bulkSet(result.list, 1, result.count);
                    return Flow.executeSequence(onAfterFetch);
                }
            }, function (ex) {
                if (_this.isDisposed) {
                }
                else {
                    getAggregate().dataFetchStatusAttr = 2;
                    throw ex;
                }
            });
        };
        BaseViewController.downloadBinary = function (content, filename) {
            var blob = content.toBlob() || new Blob([]);
            var link = document.createElement("a");
            link.style.display = "none";
            document.body.appendChild(link);
            if (blob.type) {
                link.type = blob.type;
            }
            var url = window.URL.createObjectURL(blob);
            link.href = url;
            link.download = filename;
            link.click();
            setTimeout(function () { return window.URL.revokeObjectURL(url); }, 500);
            link.remove();
        };
        BaseViewController.globalInstanceId = 0;
        return BaseViewController;
    }(BaseController));
    exports.BaseViewController = BaseViewController;
});
//# sourceMappingURL=Controller.js.map;
